<!--
 * @Author: AllezLRC 13636411941@163.com
 * @Date: 2025-03-21 14:51:02
 * @LastEditors: AllezLRC 13636411941@163.com
 * @LastEditTime: 2025-03-29 14:29:38
 * @FilePath: /wemeet-admin-new/src/views/recruitment/talent/TalentForm.vue
 * @Description: 
 * Copyright (c) 2025 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-dialog destroy-on-close :model-value="visible" title="查看表单" :width="640" @close="close" @open="open">
    <div v-if="formInfo.length" class="talent-form wemeet-description">
      <el-row v-for="item in formInfo" :key="item.id">
        <el-col class="is-label" :span="3">{{ item.formTitle }}</el-col>
        <el-col :span="21">
          <span v-if="!item.formContent">未填写</span>
          <span v-else-if="item.type === 'AREA'">{{ locationFormatter(item.formContent) }}</span>
          <el-link
            v-else-if="item.type === 'FILEUPLOAD'"
            :href="item.fileUrl"
            target="_blank"
            type="primary"
            :underline="false"
          >
            {{ item.fileName }}
          </el-link>
          <el-image
            v-else-if="item.type === 'IMGUPLOAD'"
            :preview-src-list="[item.formContent]"
            :src="item.formContent"
            style="width: 80px; height: 80px"
          />
          <span v-else>{{ item.formContent }}</span>
        </el-col>
      </el-row>
    </div>
    <template #footer>
      <el-button @click="close">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
  import { defineProps, defineEmits, ref } from 'vue'
  import { getTalentDetailForm } from '@/api/recruitment'
  import { locationFormatter } from '../helper'

  const props = defineProps({
    visible: Boolean,
    id: Number,
  })

  const emit = defineEmits(['close'])

  const loading = ref(false)

  const formInfo = ref([])

  function open() {
    getTalentDetailForm(props.id)
      .then(({ code, data }) => {
        if (code !== 200) return
        formInfo.value = data.map((e) => {
          if (e.type === 'FILEUPLOAD') {
            try {
              const { fileName, fileUrl } = JSON.parse(e.formContent)
              e.fileName = fileName
              e.fileUrl = fileUrl
            } catch (error) {}
          } else if (e.type === 'CHECKBOX') {
            e.formContent = e.formContent.replaceAll(',', '、')
          }
          return e
        })
      })
      .finally(() => {
        loading.value = false
      })
  }

  function close() {
    emit('close')
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/css/description.scss';
</style>
